import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PaymentMethods} from '../../models/payment-method.model';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AdditionalPACData, PaymentFrequency} from '../../models/additional-pac-data.model';
import {QrComponent} from '../qr/qr.component';
import {AppConstants} from '../../shared/app-constants';
import {getDefaultPaymentAmount, restrictToTwoDecimals} from '../../shared/utils/default-amount-utils';

@Component({
  selector: 'app-pay-now',
  imports: [CommonModule, FormsModule, QrComponent],
  templateUrl: './pay-now.component.html',
  styleUrl: './pay-now.component.scss',
  standalone: true
})
export class PayNowComponent implements OnChanges, OnInit {

  isInputEnabled: boolean = false;
  limitExceeded: boolean = false;
  payableExceeded: boolean = false;
  amountZero: boolean = false;

  @Input() isSelected: boolean = false;
  @Input() paymentMethodInfo!: PaymentMethods;
  @Input() pacDetails!: AdditionalPACData;
  isGenerateQrClicked: boolean = false;

  @Output() generateReceipt = new EventEmitter<boolean>();
  @Output() cardClick = new EventEmitter<string | null>();
  @Output() triggerPacDetailsUpdate = new EventEmitter<void>();
  payNowAmount: number | undefined = 0;
  enableAmountCheckbox: boolean = false;
  isFocused: boolean = false;



  constructor() {
  }

  ngOnInit() {
    this.payNowAmount = getDefaultPaymentAmount(this.pacDetails);
    this.validateAmount(this.payNowAmount);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pacDetails.balancePayable']?.currentValue != null) {
      this.payNowAmount = this.pacDetails.balancePayable;
    }
  }

  inputAmountFormatted(value: number | null | undefined): string | undefined {
    return AppConstants.inputAmountFormatted(value);
  }

  showAmountFormatted(value: number | null | undefined): string {
    return AppConstants.showAmountFormatted(value);
  }

  onSelectMethod(paymentMethod: string | null) {
    this.cardClick.emit(paymentMethod);
    this.isSelected = !this.isSelected; // Toggle the expanded view on click
  }

  toggleAmountInput(event: any) {
    const input = event.target as HTMLInputElement;
    this.isInputEnabled = input.checked;
    this.enableAmountCheckbox = input.checked;

    if (!input.checked) {
      this.payNowAmount = this.pacDetails.paymentFrequency === PaymentFrequency.I
        ? this.pacDetails?.selectedAmountPayable
        : this.pacDetails?.balancePayable;
      this.validateAmount(this.payNowAmount);
    }
  }

  onAmountBlur(event: FocusEvent) {
    this.isFocused = false;
  }

  onAmountChange(event: Event) {
    const sanitizedValue = restrictToTwoDecimals(event);
    this.payNowAmount = sanitizedValue ? Number.parseFloat(sanitizedValue) : 0;
    this.validateAmount(this.payNowAmount);
  }

  private validateAmount(amount: number | undefined): void {
    let totalLimit = this.paymentMethodInfo?.totalLimit ?? 0;
    this.payableExceeded = false;
    this.limitExceeded = false;
    this.amountZero = false;
    if(amount != undefined) {
      if (amount <= 0) {
        this.amountZero = true;
      } else if (amount > this.pacDetails.balancePayable) {
        this.payableExceeded = true;
      } else if (totalLimit !== 0 && amount > totalLimit) {
        this.limitExceeded = true;
      }
      this.isInputEnabled = !(this.payableExceeded || this.limitExceeded);
    }
  }

  isAmountValid(): boolean {
    const amount = Number(this.payNowAmount);
    const maxPayable = this.pacDetails.paymentFrequency === PaymentFrequency.I ? this.pacDetails?.selectedAmountPayable ?? 0 : this.pacDetails?.balancePayable ?? 0;
    return (!Number.isNaN(amount) && amount >= 0 && amount <= maxPayable);
  }

  handlePayNowPopupClosed() {
    this.isGenerateQrClicked = false;
    this.triggerPacDetailsUpdate.emit();
  }

  onGenerateQrClicked() {
      this.isGenerateQrClicked = true;
    }

  handleDropdownKey(event: any) {
    return AppConstants.handleDropdownKey(event);
  }
}
